import kamala from '../../kamala'
import Scrollbar from './Scrollbar'

Scrollbar.install = function (Vue) {
  kamala(Vue)
  Vue.component(Scrollbar.name, Scrollbar)
}

export default Scrollbar
